module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_5025C.0acefd57.jpg";